module.exports = __webpack_public_path__ + "static/image-we-build-cb1079120aa315ab5edc95accb0bbd81.png";